import { createSlice } from "@reduxjs/toolkit";
import { projectSlice } from "./projectSlice";
import { v4 as uuidV4 } from 'uuid';
const initialState = {
    focusedTab: null,
    tabs: [],
};
const _closeEditorTab = (state, editorTabID) => {
    state.tabs = state.tabs.filter(({ id }) => id !== editorTabID);
    if (state.focusedTab?.id === editorTabID) {
        state.focusedTab = state.tabs[0] || null;
    }
};
export const editorsSlice = createSlice({
    name: 'editor',
    initialState,
    reducers: {
        closeEditorTab: (state, { payload: editorTabID }) => (_closeEditorTab(state, editorTabID)),
        focusEditorTab: (state, { payload: editorId }) => {
            const matchingEditorTab = state.tabs.find(t => t.id === editorId);
            if (matchingEditorTab)
                state.focusedTab = matchingEditorTab;
        },
        createEditorTab: (state, { payload }) => {
            const { resourceID, viewerID } = payload;
            const newEditorTab = { id: uuidV4(), resourceID, viewerID };
            state.tabs = [...state.tabs, newEditorTab];
            state.focusedTab = newEditorTab;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(projectSlice.actions.deleteResource, (state, { payload: resourceID }) => {
            const tabsForDeletedResource = state.tabs.filter((t) => t.resourceID === resourceID);
            tabsForDeletedResource.forEach((t) => _closeEditorTab(state, t.id));
        });
    },
    selectors: {
        _getFocusedTab: (state) => state.focusedTab,
        _getTabs: (state) => state.tabs,
        hasEditorTab: (state, id) => (Boolean(state.tabs.find(t => t.id === id))),
    },
});
//# sourceMappingURL=editorsSlice.js.map